import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import AGenerateModel from 'components/generic/AGenerateModel';

import { withRouter } from 'components/withRouter';

import { saveMaterial } from "views/pages/ManageMaterials";

class ManageTickets extends Component {
    static displayName = ManageTickets.name;

    static ticketModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    modalGenManager = React.createRef();

    constructor(props) {
        super(props);

        this.ticketGen = React.createRef(null);

        var defTicketCategories = [];
        var defTicketExcludeCategories = false;
        var defTicketCategoryGroupKey = "";
        var defTicketPageModels = "";
        if (props.searchParams) {
            defTicketCategories = JSON.parse(props.searchParams.get("categories")) || [];
            defTicketExcludeCategories = props.searchParams.get("excludeCategories") === "true";
            defTicketCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defTicketPageModels = props.searchParams.get("pageModels") || "";
        }

        this.state = {
            tickets: [], curTicket: null, curTicketId: 0, status: [], defaultStatus: 7001, curStatus: 7001/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1",
            title: props.i18nManager.t("ticket.noSelected"), editionMode: false, categories: defTicketCategories, excludeCategories: defTicketExcludeCategories, categoryGroupKey: defTicketCategoryGroupKey, pageModels: defTicketPageModels
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/ticket/GetTicketModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.ticketModels = {};
                    dataModels.result.models.forEach((model) => {
                        context.ticketModels[model.extID] = JSON.parse(model.value);
                    });

                    //context.ticketModels["CONTACTS"] = {};
                    //context.ticketModels["DT_CTCS"] = {};
                    //context.ticketModels["DLG_CONTACT"] = {};
                    


                    //Chargement via url
                    var defTicketLoadId = 0;
                    var defTicketActionId = 0;
                    if (context.props.searchParams) {
                        defTicketLoadId = parseInt(context.props.searchParams.get("ticketId")) || 0;
                        defTicketActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                    }
                    if (defTicketLoadId > 0) {
                        var defTicketStatusId = parseInt(context.props.searchParams.get("statusId")) || 7001;

                        context.loadStatusBtnGrp(defTicketStatusId);

                        context.getTickets(defTicketStatusId, false, function () {
                            if (context) {
                                context.loadReportCb = () => {
                                    if (defTicketActionId) context.switchTab(defTicketActionId.toString());

                                    //setTimeout(function () {
                                    var element = document.querySelector('.tableContainer');
                                    const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                    context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                    //}, 2000);
                                };
                            }
                            showDtSelID("tableTickets", defTicketLoadId);
                        });
                    } else {
                        context.loadStatusBtnGrp(7001);

                        context.getTickets();

                        if (defTicketActionId) context.switchTab(defTicketActionId.toString());

                        /*if (defTicketActionId == 1) {
                            $(".action-addReport:visible").click();
                        }*/
                    }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports || */prevState.curStatus !== this.state.curStatus || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels || prevState.categories.toString() !== this.state.categories.toString() || prevState.excludeCategories !== this.state.excludeCategories) {
            this.getTickets();
        }
        else {
            var defTicketCategories = [];
            var defTicketExcludeCategories = false;
            var defTicketCategoryGroupKey = "";
            var defTicketPageModels = "";
            if (this.props.searchParams) {
                defTicketCategories = JSON.parse(this.props.searchParams.get("categories")) || [];
                defTicketExcludeCategories = this.props.searchParams.get("excludeCategories") === "true";
                defTicketCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defTicketPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defTicketCategoryGroupKey || this.state.categories.toString() !== defTicketCategories.toString() || this.state.excludeCategories !== defTicketExcludeCategories || this.state.pageModels !== defTicketPageModels) {
                this.setState({ categoryGroupKey: defTicketCategoryGroupKey, categories: defTicketCategories, excludeCategories: defTicketExcludeCategories, pageModels: defTicketPageModels });
            }
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateTicket
        if (this.state.curTicketId === 0 /*&& prevState.curTicketId !== this.state.curTicketId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableTickets"]) this.dtFunctions["tableTickets"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadTicket(rowData.idTicket, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idTicket;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadTicket(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadTicket();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
        var pageConfig;
        switch (context.state.pageModels) {
            case "PROSPECT":
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:ticket.tabDetails", "objType": "template", "subType": "TICKET", "checkRights": { "entity": "TICKET", "rights": "R" } },
                        { "title": "i18n:ticket.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "TICKET_CONTACTS", "rights": "L" } },
                        { "title": "i18n:ticket.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "TICKET_FILES", "rights": "L" } },
                        { "title": "i18n:ticket.tabMaterial", "objType": "template", "subType": "MATERIAL", "checkRights": { "entity": "MATERIAL", "rights": "L" } },
                        { "title": "i18n:ticket.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "TICKET_FLOWS", "rights": "L" } },
                        { "title": "i18n:ticket.tabDiscussions", "objType": "template", "subType": "TKT_DISCUSS", "checkRights": { "entity": "TICKET", "rights": "A" } }
                    ]
                };
                break;
            default:
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:ticket.tabDetails", "objType": "template", "subType": "TICKET", "checkRights": { "entity": "TICKET", "rights": "R" } },
                        { "title": "i18n:ticket.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "TICKET_CONTACTS", "rights": "L" } },
                        { "title": "i18n:ticket.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "TICKET_FILES", "rights": "L" } },
                        { "title": "i18n:ticket.tabMaterial", "objType": "template", "subType": "MATERIAL", "checkRights": { "entity": "MATERIAL", "rights": "L" } },
                        { "title": "i18n:ticket.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "TICKET_FLOWS", "rights": "L" } },
                        { "title": "i18n:ticket.tabDiscussions", "objType": "template", "subType": "TKT_DISCUSS", "checkRights": { "entity": "TICKET", "rights": "A" } }
                    ]
                };
                break;
        }

        

        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();
            var targetRoles = curUser.roles ? curUser.roles[0] : null;
            var ticketModel;
            var srcModel;
            var resFilter = Object.keys(this.ticketModels).filter((key) => {
                var model = this.ticketModels[key];
                if (key === "TICKET") {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "TICKET_" + targetRoles;
            });
            if (resFilter && resFilter.length) {
                ticketModel = this.ticketModels[resFilter[0]];
            }
            else if (srcModel) {
                ticketModel = srcModel;
            }
            else {
                ticketModel = this.ticketModels ? this.ticketModels["TICKET"] : {};
            }


            var cptSysCollection = {
                "TICKET": <ShowDetails id={this.state.curTicketId} type="ticket" genRef={this.ticketGen} data={this.state.curTicket} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={ticketModel} modelsList={this.ticketModels} loadElem={this.loadTicket.bind(this)} saveElem={this.contextSaveTicket.bind(this)} removeElem={this.removeTicket.bind(this)} updateStatusElem={this.updateTicketStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} closeTicket={this.closeTicket.bind(this)} />,
                "CONTACTS": <ShowDetails id={this.state.curTicketId} type="ticketContacts" data={this.state.curTicket} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.ticketModels ? this.ticketModels["CONTACTS"] : {}} modelsList={this.ticketModels} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="ticket-files" bindID={this.state.curTicketId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="TICKET" src={this.state.curTicket} srcName={this.state.curTicket ? this.state.curTicket.title : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"TTC"} altFilesTypes="../api/ticket/GetTicketFilesType" altFilesUrl="../api/ticket/GetTicketFiles" altRemoveFilesUrl="../api/ticket/RemoveTicketFile" altUploadFilesUrl="../api/ticket/UploadTicketFiles" />
                </Form>,
                "FLOWS": <Row className="ticket-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("ticket.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="ticket" elemId={context.state.curTicketId} url="../api/ticket/GetTicketFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
                "MATERIAL": this.state.curTicket?.assignMaterialID > 0 ? <ShowDetails id={this.state.curTicket?.assignMaterialID} type="ticketMaterial" data={this.state.curTicket?.material} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.ticketModels ? this.ticketModels["FAST_MATERIAL"] : {}} modelsList={this.ticketModels} shouldRender={this.state.activeTab === index.toString()} />
                    : <h4>{context.props.i18nManager.t("ticket.nomat")}</h4>,
                "TKT_DISCUSS": <ShowDetails id={this.state.curTicketId} type="ticket" genRef={this.ticketGen} data={this.state.curTicket} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.ticketModels ? this.ticketModels["TKT_DISCUSS"] : {}} modelsList={this.ticketModels} loadElem={this.loadTicket.bind(this)} saveElem={this.contextSaveTicket.bind(this)} removeElem={this.removeTicket.bind(this)} updateStatusElem={this.updateTicketStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} />,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };


        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.ticketModels ? <CDataTable key="tickets" dtId={"tableTickets"} data={this.state.tickets} localConfig={dtConfig} tag={"DT_TICKETS"} config={this.ticketModels["DT_TICKETS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;

        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("ticket.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getTickets()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {this.props.checkRights("TICKET", "C") ? <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateTicket()}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("ticket.add")}
                            </Button> : ""}
                        </div>
                        <CNavbar className="float-end">
                            <div className="text-end">
                                {this.state.status.map((dt) => {

                                    //TODO : statusBtnAltProc

                                    var statusClass = "form-badge-radio mb-1 ";
                                    statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                    return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                        <div className='form-check-radio fcheck-sm mb-0'>
                                            <Label check >
                                                <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                    var value = parseInt(e.target.value);

                                                    context.setState({ curStatus: value, curTicketId: 0, curTicket: null, isShowDetails: false });
                                                }} />
                                                <span className="form-check-sign" />
                                                {(() => {
                                                    var classFa = "";
                                                    if (dt.css && dt.css.indexOf("fa-")) {
                                                        dt.css.split(" ").forEach((classElem) => {
                                                            //console.debug(classElem.startsWith("fa-") + classElem);
                                                            classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                        });
                                                    }
                                                    return <i className={`fa ${classFa} me-1`}></i>
                                                })()}
                                                {altT(dt.name)}
                                            </Label>
                                        </div>
                                    </div> : "";
                                })}
                            </div>
                        </CNavbar>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curTicketId || 0;
                                        showDtPrevID("tableTickets", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curTicketId || 0;
                                        showDtNextID("tableTickets", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {pageConfig?.templates?.map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : "") )}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {pageConfig?.templates?.map((template, index) => getSysCpt(template, index+1))}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    async getTickets(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ tickets: [], curTicketId: 0, curTicket: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus || 7001;

        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        commonFunc.getMethod("../api/ticket/GetTickets", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();

                    var newTickets = response.data.result;
                    /*if (context.state.categories?.length) {
                        if (context.state.excludeCategories) newTickets = newTickets.filter(ticket => context.state.categories.indexOf(ticket.categoryID) < 0);
                        else newTickets = newTickets.filter(ticket => context.state.categories.indexOf(ticket.categoryID) >= 0);
                    }*/

                    context.setState({ tickets: newTickets, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("ticket.failLoadTickets") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("ticket.failLoadTickets")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/ticket/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadTicket(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("ticket.noSelected"), curTicketId: 0, curTicket: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                commonFunc.getMethod("../api/ticket/GetTicket", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.title + " • " + data.result.address.city), curTicketId: id, curTicket: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("ticket.failLoadTicket") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveTicket(userTicket, isUpdate) {
        var context = this;

        return saveTicket(userTicket, context.state.curTicket, isUpdate, { translation: context.props.i18nManager.t }).then((ticketResponse) => {
            context.loadTicket(ticketResponse.idTicket);//userTicket.idTicket

            return new Promise((resolve, reject) => {
                resolve(ticketResponse);
            });
        });
    }

    removeTicket(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curTicket;
            if ((!id && row) || (id && row && id === row.idTicket)) {
                id = id || row.idTicket;
                title = row.title;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("ticket.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("ticket.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/ticket/RemoveTicket", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getTickets();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateTicketStatus(statusId, stepId, customLabel) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curTicketId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadTicket = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("ticket.updStatus"),
                        html: context.props.i18nManager.t("ticket.statusAs", [label]),
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("ticket.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                            var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                            commonFunc.postMethod("../api/ticket/UpdateStatus", req).then((response) => {

                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    /*context.getTickets(0, true, () => {
                                        if (reloadTicket) showDtSelID("tableTickets", id);
                                    });*///TODO : check si besoin de refresh supplémentaire
                                    if (reloadTicket) context.loadTicket(id);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    closeTicket() {
        var context = this;

        var title = "Clôture ticket";

        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (data, isUpdate) {
            return new Promise((resolve, reject) => {
                if (data) {
                    saveTicket(data, context.state.curTicket, true, { translation: context.props.i18nManager.t, noSwal: true }).then((dataResult) => {
                        if (dataResult && dataResult.idResponse) {
                            var req = { id: context.state.curTicketId, newStatus: 7003, newStep: -1 };
                            commonFunc.postMethod("../api/ticket/UpdateStatus", req).then((response) => {
                                context.loadTicket(context.state.curTicketId);

                                //Update Material ??
                                if (context.state.curTicket?.assignMaterialID > 0 && !commonFunc.isBlank(context.state.curTicket.extRef)) {
                                    context.updateLinkedMaterial(context.state.curTicket);
                                }
                                else {
                                    Swal.fire({
                                        icon: "success",
                                        title: context.props.i18nManager.t("gal_success"),
                                        html: context.props.i18nManager.t("gal_successUpd"),
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    });
                                }
                            });
                            context.modalRoot.unmount();
                            resolve(dataResult);
                        }
                        else {
                            resolve(dataResult);
                        }
                    });
                }
                else {
                    context.modalRoot.unmount();
                    resolve();
                }
            });
        };
        if (this.ticketModels["DLG_CLOSING"]) {
            this.modalRoot = createRoot(document.createElement('div'));
            this.modalRoot.render(<ClosingModal parentContext={this} title={title} configModel={this.ticketModels["DLG_CLOSING"]} modelsList={this.ticketModels} dataTicket={context.state.curTicket} callback={callbackModal}></ClosingModal>);
        }
        else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_error"),
                html: "Configuration introuvable"
            });
        }
    }

    updateLinkedMaterial(ticketSrc) {
        console.debug("should UPDATE MATERIAL");

        var context = this;

        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });

        var args = {};
        //args.state = 201;
        args.id = ticketSrc.assignMaterialID;
        args.level = 3;

        commonFunc.getMethod("../api/material/GetMaterial", args).then((response) => {
            var data = response.data;
            if (data.isSuccess) {
                console.log(data.result);

                var swalSuccess = () => {
                    Swal.fire({
                        icon: "success",
                        title: context.props.i18nManager.t("gal_success"),
                        html: context.props.i18nManager.t("gal_successUpd"),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });
                };

                if (data.result?.materialAssigns) {
                    var mtnAssign = data.result.materialAssigns?.filter(assign => assign.service?.refExtID === "608" && assign.statusExt === "EC" && assign.endDate === "2099-12-31" && ticketSrc.extRef === "MATMTN-" + assign.idAssign);
                    if (mtnAssign?.length) {
                        mtnAssign[0].endDate = new Date().toISOString().substring(0, 10);
                        mtnAssign[0].statusExt = "OK";

                        data.result.statusID = 4002;//4007 si non dispo
                        data.result.stepID = -1;

                        saveMaterial(data.result, null, true, { translation: context.props.i18nManager.t, noSwal: true }).then((responseMaterial) => {
                            if (responseMaterial?.idResponse) {
                                swalSuccess();
                            }
                        });
                    }
                    else {
                        console.debug("NO MTN MATERIALASSIGNS");
                        swalSuccess();
                    }
                }
                else {
                    console.debug("NO MATERIALASSIGNS");
                    swalSuccess();
                }

                Swal.close();
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: "Echec de récupération du matériel assigné :<br>" + data.errorMessage
                });
            }
        });
    }

    initCreateTicket() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableTickets");
        //this.ticketGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("ticket.create"), curTicketId: 0, curTicket: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curTicket ? this.state.curTicket.title : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("ticket.duplicate") : this.props.i18nManager.t("ticket.edit")) + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageTickets));

function ClosingModal({ title, parentContext, noScroll, configModel, modelsList, dataTicket, callback }) {

    return (
        <Modal isOpen={true} className={`modal-ticket visitModal ${noScroll ? "modal-noscroll" : ""}`} size="lg" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <AGenerateModel parentProps={{ type: "ticket", dataCfg: parentContext.props.dataCfg }} ref={parentContext.modalGenManager} noButtons onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={parentContext.props} checkRights={parentContext.props.checkRights} getRoutes={parentContext.props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dataTicket} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => {
                    var generateModel = parentContext.modalGenManager.current;
                    if (generateModel && generateModel.submitForm) {
                        generateModel.submitForm();
                    }
                }}><i className="fa fa-file-signature"></i>Clôturer</Button>
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button>
            </ModalFooter>
        </Modal>
    );
}
    

export async function saveTicket(userTicket, dataTicket, isUpdate, args) {
    dataTicket = dataTicket || {};

    Swal.fire({
        title: args.translation("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    if (!userTicket.avoidMerge) {
        userTicket = commonFunc.mergeDeep({}, dataTicket, userTicket);

        userTicket.parent = null;
        userTicket.group = null;
        userTicket.category = null;
        userTicket.site = null;
        userTicket.extSite = null;
        userTicket.extraSite = null;
        userTicket.client = null;
        userTicket.employee = null;
        userTicket.material = null;
        userTicket.status = null;
        userTicket.subStatus = null;
        userTicket.tenantUserAccess = null;
    }

    console.debug(userTicket);
    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
    return commonFunc.postMethod(isUpdate ? "../api/ticket/UpdateTicket" : "../api/ticket/CreateTicket", userTicket).then((response) => {
        Swal.close();
        return new Promise((resolve, reject) => {
            var data = response.data;
            if (data && data.isSuccess) {

                var nextProc = () => {
                    /*if (context.state.curStatus !== data.result.statusID) {
                        context.setState({ curStatus: data.result.statusID });
                        context.refreshCb = () => {
                            showDtSelID("tableTickets", data.result.idTicket);
                        };
                    }
                    else {
                        context.getTickets(0, true, () => {
                            showDtSelID("tableTickets", data.result.idTicket);
                        });
                    }*/

                    data.result.idResponse = data.result.idTicket;
                    resolve(data.result);
                };


                if (args.noSwal) {
                    nextProc();
                }
                else {
                    Swal.fire({
                        icon: "success",
                        title: args.translation("gal_success"),
                        html: (isUpdate ? args.translation("gal_successUpd") : args.translation("gal_successAdd")),
                        didOpen: () => { Swal.hideLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        nextProc();
                    });
                }
            } else {
                var supErrors = "";
                if (data.errors && data.errors.length) {
                    supErrors = data.errors.map((error) => {
                        return "<br>" + error.desc + "(" + error.value + ")";
                    });
                }
                Swal.fire({
                    icon: "error",
                    title: args.translation("gal_fail"),
                    html: args.translation("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                });
                resolve(data);
            }
        });
    });
}